import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-delete',
	path: '/secure/admin/DeleteFieldLayoutScheme([!%]?[\\w]*).jspa',
};
